export const REVIEW_GUIDE_MESSAGES = [
  '작성하신 리뷰는 닉네임, 프로필 이미지와 함께 누구나 볼 수 있도록 공개돼요. 리뷰 내용에 민감한 정보가 포함되지 않도록 주의해주세요.',
  '솔직하게 작성하신 리뷰는 상품 구매를 고민하시는 분에게 큰 도움이돼요. 하지만 허위 리뷰나 명예훼손, 욕설, 타인비방글 등 제 3자의 권리를 침해하는 리뷰의 경우 서비스 이용약관이나 관련 법률에 따라 제재를 받을 수 있어요.',
  '에이비제트(주)는 위와 같은 게시물 작성자에게 경고, 주의 등의 조치를 취할 수 있으며, 해당 리뷰를 삭제하거나 보이지 않게 할 수 있어요. 게시에 따른 책임은 본인에게 있으며 에이비제트(주)는 이에 대한 법적 책임을 지지않아요.',
  '작성해주신 리뷰의 저작권은 에이비제트(주)에 귀속돼요.',
];

export const REVIEW_IMAGE_GUIDE_MESSAGES = [
  '업로드 가능한 최대 이미지 사이즈는 10MB 입니다.',
  '구매한 상품과 관련 없는 이미지를 업로드 하실 경우, 통보 없이 삭제될 수 있어요.',
];

export const REVIEW_SESSION_KEY = 'reviewOrderline';
